/**
 * เมนูสต๊อกสินค้า - โครงสร้างตาม foodorder สไตล์เหมือนเมนู thunderbee ปกติ
 */
import { Link, useLocation } from "react-router-dom";
import {
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import {
  Inventory2 as Inventory2Icon,
  Description as DescriptionIcon,
} from "@mui/icons-material";
import { useState } from "react";
import { hasPathReadAccess } from "../../../utils/orgAccessPermissions";

const ROUTES = [
  { to: "/stock/stock-overview", icon: <Inventory2Icon />, label: "สต๊อกสินค้าทั้งหมด" },
  { to: "/stock/stock-documents", icon: <DescriptionIcon />, label: "เอกสารงานคลัง" },
  { to: "/withdraw-approval", icon: <DescriptionIcon />, label: "อนุมัติใบขอเบิก" },
];

const ACTIVE_PATHS = ["/stock/stock-overview", "/stock/stock-detail", "/stock/stock-documents", "/withdraw-approval"];

export default function StockManagementMenu({ collapsed, sectionVisible }) {
  const [hovered, setHovered] = useState(false);
  const location = useLocation();

  if (!sectionVisible) return null;

  const routes = ROUTES.filter((r) => hasPathReadAccess(r.to));
  if (routes.length === 0) return null;

  const isActive = (path) =>
    path && (location.pathname === path || location.pathname.startsWith(path + "/"));

  const sectionActive = ACTIVE_PATHS.some(isActive);

  const NavItem = ({ to, icon, label }) => {
    const selected = isActive(to);
    const button = (
      <ListItemButton
        component={Link}
        to={to}
        selected={selected}
        sx={{
          borderRadius: 1.5,
          mb: 0.5,
          px: 1.5,
          justifyContent: "flex-start",
          minHeight: 48,
          transition: "background-color 0.2s ease, color 0.2s ease",
          "&:hover": {
            bgcolor: "rgba(225, 63, 87, 0.12)",
            color: "#E13F57",
            "& .MuiListItemIcon-root": { color: "#E13F57" },
          },
          "&.Mui-selected": {
            bgcolor: "primary.main",
            color: "primary.contrastText",
            "& .MuiListItemIcon-root": { color: "primary.contrastText" },
            "&:hover": { bgcolor: "#c42d44" },
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 36,
            width: 36,
            height: 36,
            display: "flex",
            alignItems: "center",
            color: selected ? "primary.contrastText" : "#6b7280",
            justifyContent: "center",
            "& svg": { fontSize: "1.5rem", width: "1.5rem", height: "1.5rem" },
          }}
        >
          {icon}
        </ListItemIcon>
        <ListItemText
          primary={label}
          sx={{ my: 0, alignSelf: "center" }}
          primaryTypographyProps={{ lineHeight: 1.2, display: "block" }}
        />
      </ListItemButton>
    );
    return button;
  };

  return (
    <Tooltip title={collapsed ? "สต๊อกสินค้า" : ""} placement="right">
      <Box
        sx={{ position: "relative" }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <ListItemButton
          sx={collapsed ? {
            borderRadius: 1.5,
            mb: 0.25,
            px: 0,
            justifyContent: "center",
            minHeight: 40,
            "&:hover": { bgcolor: "transparent" },
          } : {
            borderRadius: 1.5,
            mb: 0.5,
            alignItems: "center",
            bgcolor: sectionActive ? "rgba(225, 63, 87, 0.1)" : "transparent",
            "&:hover": { bgcolor: "rgba(225, 63, 87, 0.1)" },
          }}
        >
          <ListItemIcon
            sx={collapsed ? {
              minWidth: 0,
              width: 40,
              height: 40,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: sectionActive ? "primary.contrastText" : "#6b7280",
              bgcolor: sectionActive ? "primary.main" : "grey.100",
              transition: "background-color 0.2s ease, color 0.2s ease",
              ".MuiListItemButton-root:hover &": {
                bgcolor: sectionActive ? "primary.main" : "grey.200",
                color: sectionActive ? "primary.contrastText" : "#E13F57",
              },
            } : {
              minWidth: 36,
              width: 36,
              height: 36,
              display: "flex",
              alignItems: "center",
              color: sectionActive ? "#E13F57" : "#6b7280",
              "& svg": { fontSize: "1.5rem", width: "1.5rem", height: "1.5rem" },
            }}
          >
            <Inventory2Icon />
          </ListItemIcon>
          {!collapsed && (
            <ListItemText
              primary="สต๊อกสินค้า"
              sx={{ my: 0 }}
              primaryTypographyProps={{
                lineHeight: 1,
                color: sectionActive ? "#E13F57" : "#111827",
                fontWeight: sectionActive ? 600 : 500,
              }}
            />
          )}
        </ListItemButton>
        {hovered && (
          <Box
            sx={{
              position: "absolute",
              left: "100%",
              top: 0,
              minWidth: 250,
              maxHeight: 420,
              overflowY: "auto",
              bgcolor: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: 2,
              boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
              p: 1,
              zIndex: 3000,
            }}
          >
            {routes.map(({ to, icon, label }) => (
              <NavItem key={to} to={to} icon={icon} label={label} />
            ))}
          </Box>
        )}
      </Box>
    </Tooltip>
  );
}
